/* Listicle Nasal Addiction JS */
document.addEventListener('DOMContentLoaded', function () {
  /* sticky: zichtbaar vanaf punt 1, weg zodra de knop in de buybox in beeld komt */
  (function () {
    var bar = document.getElementById('sticky');
    var start = document.getElementById('reden-1');
    var knop = document.getElementById('buyboxAtc');
    if (!bar || !start || !knop) return;

    function check() {
      var aan = start.getBoundingClientRect().top < window.innerHeight * 0.5;
      var r = knop.getBoundingClientRect();
      var atcInBeeld = r.top < window.innerHeight && r.bottom > 0;
      bar.classList.toggle('zichtbaar', aan && !atcInBeeld);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  })();

  /* variantkaart aanklikken selecteert die variant in de buybox */
  (function () {
    var tegels = [].slice.call(document.querySelectorAll('.var-item[data-var]'));
    var titel = document.getElementById('pTitel');
    var foto = document.querySelector('#carousel img');
    var thumb = document.querySelector('#carThumbs img');
    var label = document.getElementById('varLabel');

    function kies(v) {
      var t = tegels.filter(function (x) { return x.dataset.var === v; })[0];
      if (!t) return;
      tegels.forEach(function (x) { x.classList.toggle('actief', x === t); });
      if (titel && t.dataset.titel) titel.textContent = t.dataset.titel;
      if (label && t.dataset.naam) label.textContent = t.dataset.naam;
      if (foto && t.dataset.foto) foto.src = t.dataset.foto;
      if (thumb && t.dataset.foto) thumb.src = t.dataset.foto;

      // If shopify variant select exists
      var variantInput = document.querySelector('input[name="id"], select[name="id"]');
      if (variantInput && t.dataset.variantId) {
        variantInput.value = t.dataset.variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    tegels.forEach(function (t) {
      t.addEventListener('click', function () { kies(t.dataset.var); });
    });

    // drie punten onder de mobiele variantkaarten
    var lijst = document.getElementById('varLijst');
    var dots = [].slice.call(document.querySelectorAll('#varDots .vdot'));
    var kaarten = lijst ? [].slice.call(lijst.querySelectorAll('.vkaart')) : [];
    if (lijst && dots.length === kaarten.length) {
      var raf = null;
      var zetActieveDot = function () {
        var midden = lijst.scrollLeft + lijst.clientWidth / 2;
        var actief = 0;
        var afstand = Infinity;
        kaarten.forEach(function (kaart, index) {
          var kaartMidden = kaart.offsetLeft + kaart.offsetWidth / 2;
          var verschil = Math.abs(kaartMidden - midden);
          if (verschil < afstand) {
            afstand = verschil;
            actief = index;
          }
        });
        dots.forEach(function (dot, index) {
          var isActief = index === actief;
          dot.classList.toggle('actief', isActief);
          if (isActief) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        var dotsContainer = document.getElementById('varDots');
        if (dotsContainer) {
          dotsContainer.setAttribute('aria-label', 'Variant ' + (actief + 1) + ' van ' + kaarten.length);
        }
      };
      lijst.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(zetActieveDot);
      }, { passive: true });
      window.addEventListener('resize', zetActieveDot);
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          kaarten[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
      zetActieveDot();
    }

    // TCC 17-09-2026: "Kies ..." selecteert het juiste type in de buybox via de swatch zelf,
    // zodat titel, fotos, Kaching en de winkelwagen-variant exact meeschakelen.
    // Match op kaarttitel + knoptekst (de data-variant-sleutels "blauw"/"roze" kloppen niet met de kaarten).
    function kiesBuyboxType(knop) {
      try {
        var kaart = knop.closest('.vkaart-card, .var-item');
        var tekst = (((kaart && kaart.getAttribute('data-titel')) || '') + ' ' + (knop.textContent || '')).toLowerCase();
        var typen = [
          { kaart: /transparant/, swatch: /transparant/ },
          { kaart: /gevoelig/, swatch: /gevoelig/ },
          { kaart: /classic|klassiek/, swatch: /classic/ }
        ].filter(function (t) { return t.kaart.test(tekst); });
        if (typen.length !== 1) return;
        var bak = document.getElementById('bundel') || document;
        var kandidaten = [].slice.call(bak.querySelectorAll('.fpb-swatch-btn[data-title]')).filter(function (s) {
          return typen[0].swatch.test((s.getAttribute('data-title') || '').toLowerCase());
        });
        var kleur = /roze|pink/.test(tekst) ? /roze|pink/ : (/blauw|blue/.test(tekst) ? /blauw|blue/ : null);
        if (kleur) {
          var opKleur = kandidaten.filter(function (s) { return kleur.test((s.getAttribute('data-title') || '').toLowerCase()); });
          if (opKleur.length) kandidaten = opKleur;
        }
        var doel = kandidaten.filter(function (s) { return !s.classList.contains('sold-out'); })[0];
        if (!doel || doel.classList.contains('active')) return;
        doel.click();
        // de buybox negeert klikken kort na een vorige wissel: dan een keer opnieuw
        if (!doel.classList.contains('active')) {
          setTimeout(function () {
            if (!doel.classList.contains('active') && !doel.classList.contains('sold-out')) doel.click();
          }, 450);
        }
      } catch (e) {}
    }

    // variantkaarten: de knop kiest de variant in de buybox en scrollt erheen
    document.querySelectorAll('.vkies[data-variant]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        kies(knop.dataset.variant);
        kiesBuyboxType(knop);
        var target = document.getElementById('bundel');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  /* bezorgdatum: PDP-logica, voor 16:00 op werkdagen besteld = volgende werkdag in huis */
  (function () {
    var CUTOFF = 16;
    var WD = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
    var MND = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    function nlTijd() {
      var d = new Date();
      try { return new Date(d.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); } catch (e) { return d; }
    }
    function isWerkdag(d) { return d.getDay() >= 1 && d.getDay() <= 5; }
    function volgendeWerkdag(d) {
      var n = new Date(d);
      do { n.setDate(n.getDate() + 1); } while (!isWerkdag(n));
      return n;
    }
    var el = document.getElementById('leverRegel');
    if (!el) return;
    var nu = nlTijd();
    var voorCutoff = isWerkdag(nu) && nu.getHours() < CUTOFF;
    var verzend = voorCutoff ? new Date(nu) : volgendeWerkdag(nu);
    var lever = volgendeWerkdag(verzend);
    var morgen = new Date(nu);
    morgen.setDate(morgen.getDate() + 1);
    var isMorgen = lever.getFullYear() === morgen.getFullYear() && lever.getMonth() === morgen.getMonth() && lever.getDate() === morgen.getDate();
    el.innerHTML = 'Bestel nu, <b>' + (isMorgen ? 'morgen ' : '') + WD[lever.getDay()] + ' ' + lever.getDate() + ' ' + MND[lever.getMonth()] + '</b> in huis';
  })();

  /* reviews toggle & show more */
  (function () {
    var lijst = document.getElementById('rvlijst');
    if (!lijst) return;
    lijst.addEventListener('click', function (e) {
      var knop = e.target.closest('.rvmeer');
      if (!knop) return;
      var kaart = knop.closest('.rvkaart');
      var open = kaart.classList.toggle('rvopen');
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      knop.textContent = open ? 'Lees minder' : 'Lees verder';
    });
    // toon Lees verder alleen als de tekst echt wordt afgekapt
    [].slice.call(lijst.querySelectorAll('.rvkaart.rvlang')).forEach(function (kaart) {
      var tekst = kaart.querySelector('.rvtekst');
      var knop = kaart.querySelector('.rvmeer');
      if (tekst && knop && tekst.scrollHeight <= tekst.clientHeight + 3) {
        kaart.classList.remove('rvlang');
        knop.remove();
      }
    });
    var kaarten = [].slice.call(lijst.querySelectorAll('.rv-card, .rvkaart'));
    var meerknop = document.getElementById('rvmeerknop');
    var zichtbaar = 6;
    function toon() {
      kaarten.forEach(function (k, i) { k.classList.toggle('verborgen', i >= zichtbaar); });
      if (meerknop && meerknop.parentElement && zichtbaar >= kaarten.length) {
        meerknop.parentElement.style.display = 'none';
      }
    }
    toon();
    if (meerknop) {
      meerknop.addEventListener('click', function () {
        zichtbaar += 6;
        toon();
      });
    }
  })();
});